"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const checkbox_1 = require("@reach/checkbox");
const react_1 = (0, tslib_1.__importDefault)(require("react"));
const S = (0, tslib_1.__importStar)(require("./styles"));
const Checkbox = (_a) => {
    var { children, disabled = false } = _a, props = (0, tslib_1.__rest)(_a, ["children", "disabled"]);
    const [checkedState, setChecked] = react_1.default.useState(props.checked || false);
    const checked = props.checked != null ? props.checked : checkedState;
    return ((0, jsx_runtime_1.jsxs)(S.StyledLabel, Object.assign({ disabled: disabled, checked: props.checked != null ? props.checked : checked, htmlFor: props.name }, { children: [(0, jsx_runtime_1.jsx)(checkbox_1.CustomCheckbox, Object.assign({}, props, { onChange: (event) => setChecked(event.target.checked) }), void 0), children] }), void 0));
};
exports.default = Checkbox;
